module.exports = __webpack_public_path__ + "img/collection-weddingRingsDiamonds.eff9a7d.webp";